import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/hooks";
import DiagnosticRegisterForm from "./diagnosticRegisterForm";
import SuccessModalV2 from "@/components/Organisms/SuccessModal/V2/ModalV2";
import { DEFAULT_URL_ARGUMENTS } from "@/constants";
import { useRegisterForm } from "../../../hooks";
import { sendDiagnosticFormData } from "@/redux/DiagnosticReducer";
import { timezone } from "@/utils";
import BodyTemplate from "../BodyTemplate";
import Heading from "../BodyTemplate/Heading";
import {
  StyledTwoColumnModal,
  Title,
  InnerColumn,
  Subtitle,
  ContactUsSection,
  ContactBlock,
  ContactHeading,
  ContactValue,
  ContactLink,
  LHSSection,
  ImageBox,
  ImageHolder,
  ImageDiv,
  ContactIcon,
  PhoneIcon,
  StyledFormFieldBox,
  TitleImage,
} from "./formStyle";

function PartnerForm(
  {
    count,
    width,
    setShowModal,
    title,
    forms,
    subtitle,
    urlParams,
    selectedPackage,
  },
  ref
) {
  const { countryCodeData } = useAppSelector((state) => state.dashboard);
  const {
    isLoading: isThisPageLoading,
    handleChange,
    handleSelectChange,
    onSubmitCallback,
    inputs,
    showSuccessModal,
    onShowCallbackModal,
    onHideCallbackModal,
    isAllInputsFilled,
    handleCheckBoxChange,
  } = useRegisterForm({
    name: "",
    countryCode: countryCodeData?.default?.code || "+91",
    mobile: "",
    goal: {
      label: selectedPackage?.title || "",
      slug: selectedPackage?.slug || "",
    },
    location: "",
    pinCode: "",
    email: "",
    termsCondition: false,
  });
  const dispatch = useAppDispatch();

  const {
    name,
    countryCode,
    mobile,
    goal,
    location,
    pinCode,
    email,
    termsCondition,
  } = inputs;

  const urlsArguments = urlParams ? urlParams : DEFAULT_URL_ARGUMENTS;
  const onSubmit = () => {
    let apiData = {
      name: name,
      mobile: mobile,
      phone_prefix: countryCode || "+91",
      package: selectedPackage?.slug,
      urls_arguments: urlsArguments,
      timezone: timezone,
      city: location,
      pincode: pinCode,
      email: email,
      mapping_slug: forms?.partnerSlug,
      partner: forms?.partnerName,
    };

    return dispatch(sendDiagnosticFormData({ data: apiData })).then(() => {
      onShowCallbackModal();
    });
  };
  const {
    isFormSubmitting: postIsLoading,
    formSubmitError: postError,
    formSubmitSuccess: postSuccess,
  } = useAppSelector((state) => state.diagnosticPage);
  const isLoading = postIsLoading;
  const success = postSuccess;
  const error = postError;

  const onSubmitButtonClick = (e) => {
    e.preventDefault();
    onSubmitCallback(true, onSubmit);
  };

  const onHide = () => setShowModal(false);

  useEffect(() => {
    if (showSuccessModal && !error) {
      setTimeout(() => onHideCallbackModal(onHide), 6000);
    }
  }, [showSuccessModal]);
  const leftSection = (
    <LHSSection flexDirection="column" width="100%">
      <InnerColumn flexDirection="column" flex="1">
        <TitleImage>
          {forms?.partnerLogo && (
            <ImageDiv>
              <ImageBox>
                <ImageHolder src={forms.partnerLogo} />
              </ImageBox>
            </ImageDiv>
          )}
          <Title
            variant="heading2"
            dangerouslySetInnerHTML={{ __html: forms?.title }}
          />
        </TitleImage>
        <Subtitle variant="paragraph1">{forms?.subTitle}</Subtitle>
        {(forms?.contact || forms?.emailUs) && (
          <ContactUsSection>
            {forms?.whatsapp && (
              <ContactBlock>
                <ContactIcon icon="icon-whatsapp" />
                <ContactHeading variant="paragraph2">
                  {forms?.whatsappTitle}
                </ContactHeading>
                <ContactLink
                  href={`https://wa.me/91${forms?.whatsapp?.replaceAll(
                    "-",
                    ""
                  )}`}
                  variant="link1"
                  target="_blank"
                >
                  <ContactValue variant="heading6">
                    {forms?.whatsapp}
                  </ContactValue>
                </ContactLink>
              </ContactBlock>
            )}
            {forms?.contact && (
              <ContactBlock>
                <PhoneIcon icon="icon-PhoneCall" />
                <ContactHeading variant="paragraph2">
                  {forms?.callUs}
                </ContactHeading>
                <ContactLink href={`tel:${forms?.contact}`} variant="link1">
                  <ContactValue variant="heading6">
                    {forms?.contact}
                  </ContactValue>
                </ContactLink>
              </ContactBlock>
            )}
          </ContactUsSection>
        )}
      </InnerColumn>
    </LHSSection>
  );
  const rightSection = (
    <StyledFormFieldBox isFormSubmitted={success && showSuccessModal}>
      {!(success && showSuccessModal) && (
        <DiagnosticRegisterForm
          isLoading={isLoading && isThisPageLoading}
          showLabels={false}
          {...inputs}
          error={!success && error}
          onSubmitButtonClick={onSubmitButtonClick}
          handleChange={handleChange}
          handleSelectChange={handleSelectChange}
          // Name
          namePlaceholder="Full Name"
          // Phone
          phonePlaceholder="Your Phone Number"
          // Button
          buttonText={forms?.ctaTitle || "Submit"}
          buttonPadding="15px 32px"
          //goal
          showGoalsField
          goalPlaceholder="Select condition"
          goal={goal ? goal : null}
          homePageButton
          isAllInputsFilled={isAllInputsFilled}
          variant="v3"
          dropdownDisable
          nameIcon=""
          showEmailField
          goalLabel="Package Selected"
          emailPlaceholder="Your Email"
          showLocation
          showPinCode
          focusable
          handleCheckBoxChange={handleCheckBoxChange}
          termsCondition={termsCondition}
          chkId="termsCondition"
          checkboxLabelText={`I agree to ${forms?.partnerName} Terms & Conditions and Privacy Policy`}
        />
      )}
      {success && showSuccessModal && (
        <SuccessModalV2
          successImage={forms?.successImage}
          submissionTitle={forms?.submissionTitle}
          submissionSubtitle={forms?.submissionSubtitle}
          contentAlign={"flex-start"}
          headingVariant="heading3"
          imageHeight="160px"
          imageWidth="174px"
        />
      )}
    </StyledFormFieldBox>
  );
  return (
    <BodyTemplate
      isForm
      p={width > 1079 ? "25px 24px" : "24px 0px 0px"}
      isLastSection
      ref={ref}
    >
      <Heading data={{ title, subtitle, count }} />
      <StyledTwoColumnModal
        leftSection={leftSection}
        rightSection={rightSection}
      />
    </BodyTemplate>
  );
}

export default React.forwardRef(PartnerForm);
